import axios from "axios";
export const togglePriority = async (item, currentPriority, cb) => {
  const newPriority = (currentPriority || item.priority) === 'high' ? 'low' : 'high';

  try {
    await axios.put(`/api/requests/${item.id}/admin`, {
      priority: newPriority,
    });

    cb(newPriority);
  } catch (err) {
    console.log(err);
  }
}
